import { render, staticRenderFns } from "./MySpaceTasksWidgets.vue?vue&type=template&id=298da601&scoped=true&"
import script from "./MySpaceTasksWidgets.vue?vue&type=script&lang=js&"
export * from "./MySpaceTasksWidgets.vue?vue&type=script&lang=js&"
import style0 from "./MySpaceTasksWidgets.vue?vue&type=style&index=0&id=298da601&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298da601",
  null
  
)

export default component.exports